import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment as env } from "@environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class LandingService {
  constructor(private http: HttpClient) {}

  public sendLead(body): Observable<any> {
    return this.http.post<any>(`${env.gateway.base_url}${env.gateway.gateway_prefix}leads/`, {
      ...body,
      business_type: body.businessType,
      order_estimate: body.orderEstimate,
    });
  }
}
